var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgGroup = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2679 6.40625H9.33984C9.43444 6.66523 9.48612 6.94473 9.48612 7.23603V10.7435C9.48612 10.8649 9.46498 10.9815 9.42652 11.0899H10.9608C11.5339 11.0899 12.0001 10.6236 12.0001 10.0506V8.1385C12.0001 7.18335 11.2231 6.40625 10.2679 6.40625Z",
    fill: "#535961"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.51403 7.23603C2.51403 6.9447 2.56571 6.66523 2.6603 6.40625H1.73227C0.777095 6.40625 0 7.18334 0 8.13852V10.0506C0 10.6237 0.466243 11.0899 1.03936 11.0899H2.57363C2.53517 10.9815 2.51403 10.8649 2.51403 10.7435V7.23603Z",
    fill: "#535961"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.0609 5.50391H4.9393C3.98412 5.50391 3.20703 6.281 3.20703 7.23618V10.7436C3.20703 10.9349 3.36214 11.0901 3.55348 11.0901H8.44671C8.63806 11.0901 8.79317 10.9349 8.79317 10.7436V7.23618C8.79317 6.281 8.01607 5.50391 7.0609 5.50391Z",
    fill: "#535961"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99977 0.910156C4.85105 0.910156 3.9165 1.8447 3.9165 2.99345C3.9165 3.77263 4.34656 4.45314 4.98167 4.81042C5.28291 4.97988 5.6302 5.07672 5.99977 5.07672C6.36933 5.07672 6.71662 4.97988 7.01787 4.81042C7.653 4.45314 8.08303 3.77261 8.08303 2.99345C8.08303 1.84473 7.14848 0.910156 5.99977 0.910156Z",
    fill: "#535961"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.3417 2.85156C1.4826 2.85156 0.783691 3.55047 0.783691 4.40957C0.783691 5.26868 1.4826 5.96758 2.3417 5.96758C2.55962 5.96758 2.76714 5.92244 2.95565 5.8413C3.28157 5.70098 3.55031 5.45259 3.7166 5.14146C3.83331 4.92309 3.89971 4.67397 3.89971 4.40957C3.89971 3.55049 3.20081 2.85156 2.3417 2.85156Z",
    fill: "#535961"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.65811 2.85156C8.79901 2.85156 8.1001 3.55047 8.1001 4.40957C8.1001 4.674 8.1665 4.92311 8.28322 5.14146C8.44951 5.45261 8.71824 5.70101 9.04416 5.8413C9.23267 5.92244 9.44019 5.96758 9.65811 5.96758C10.5172 5.96758 11.2161 5.26868 11.2161 4.40957C11.2161 3.55047 10.5172 2.85156 9.65811 2.85156Z",
    fill: "#535961"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGroup, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/group.9d69fb58.svg";
export { ForwardRef as ReactComponent };